import React from 'react';
import dollars from '../../dollar-format';

function integer(value) {
	if (value === undefined || value === null || value === '') return '';
	return Math.round(Number(value)).toLocaleString();
}

function percent(value) {
	if (value === undefined || value === null || value === '') return '';
	return Number(value).toFixed(2)+'%';
}

const ListStats = (props) => {
	const { stats, query } = props;
    const isHSC = query.SOURCE === 'HSC';
    const isClosed = query.CLOSE_OF_ESCROW_MIN || query.CLOSE_OF_ESCROW_MAX || query.STATUS === 'Closed,' || query.HSC_STATUS === 'Closed,';

	// check if filtered status is exclusively 'In Negotiation', 'Under Contract', or a combination of the two
	let isNegotiation = false;
	if (query.STATUS) {
		const status = query.STATUS.split(',');
		let count = 0;
		if (status.indexOf('In Negotiation') !== -1) {
			count++;
		}
		if (status.indexOf('Under Contract') !== -1) {
			count++;
		}
		if (count && count === status.length - 1) {
			isNegotiation = true;
		}
	}

	let columns = [
		{
			key: 'no-key',
			label: '# of Properties',
			format: function() {
				try {
					return Number(stats.count).toLocaleString();
				} catch (err) {
					return '';
				}
			},
		},
		{
			key: 'total-price',
			label: 'Total Price',
			format: function() {
				let key;

				if (isNegotiation) {
					key = 'TOTAL_NEGOTIATION_PRICE';
				} else if (isClosed) {
					key = 'TOTAL_SOLD_PRICE';
				} else if (isHSC) {
                    key = 'TOTAL_HSC_PRICE';
                } else {
					key = 'TOTAL_LIST_PRICE';
				}

				return dollars(stats[key]);
			},
		},
		{
			key: 'TOTAL_SQFT',
			label: 'Total SQ FT',
			format: integer,
		},
	];

	if (isHSC) {
        columns.push({
            key: 'TOTAL_LOAN_AMOUNT',
            label: 'Total Loan Volume',
            format: dollars,
        }, {
        	key: 'LOAN_AMOUNT',
			label: 'Loan Amount - Ave',
			format: dollars,
		}, {
        	key: 'LTV',
			label: 'LTV – Ave',
			format: percent,
		}, {
        	key: 'INTEREST_RATE',
			label: 'Rate – Ave',
			format: percent,
		}, {
        	key: 'LENDERS',
			label: '# of Lenders',
			format: integer,
        });
	} else {
        if (isClosed) {
            columns.push({
                key: 'SOLD_PRICE',
                label: 'Price at Close – Ave',
                format: dollars,
            }, {
                key: 'CLOSE_CAP_RATE',
                label: 'Cap Rate at Close – Ave',
                format: percent,
            }, {
                key: 'NET_OPERATING_INCOME',
                label: 'NOI – Ave',
                format: dollars,
            });
        }

        columns.push({
			key: 'LIST_PRICE',
			label: 'List Price – Ave',
			format: dollars,
		}, {
        	key: 'CAPITALIZATION_RATE',
			label: 'List Cap Rate – Ave',
			format: percent,
		});

        if (!isClosed) {
            columns.push({
                key: 'NET_OPERATING_INCOME',
                label: 'NOI – Ave',
                format: dollars,
            })
        }

        if (isNegotiation) {
            columns.push({
                key: 'NEGOTIATION_PRICE',
                label: 'Neg. Price – Ave',
                format: dollars,
            }, {
                key: 'NEGOTIATION_CAP_RATE',
                label: 'Neg. Cap Rate – Ave',
                format: percent,
            })
        }

        if (isClosed) {
            columns.push({
                key: 'CLOSE_PRICE_PER_SQFT',
                label: 'Close PSF – Ave',
                format: dollars,
            })
        } else if (isNegotiation) {
            columns.push({
                key: 'NEGOTIATION_PRICE_PER_SQFT',
                label: 'Neg. PSF – Ave',
                format: dollars,
            });
        } else {
            columns.push({
                key: 'PRICE_PER_SQFT',
                label: 'PSF – Ave',
                format: dollars,
            });
        }

        columns.push({
            key: 'RENT_PER_SQFT',
            label: 'Rent / SQ FT – Ave',
            format: dollars,
        });

        columns.push({
            key: 'SQFT',
            label: 'SQ FT – Ave',
            format: integer,
        }, {
            key: 'VACANCY',
            label: 'Occupancy – Ave',
            format: percent,
        });
    }

	return stats ? (
		<div className='ListStats'>
			{
				columns.map(col => (
					<div className='ListStats_li' key={col.key}>
						<span className='ListStats_li_avg'>{col.format(stats[col.key])}</span>
						<span className='ListStats_li_name'>{col.label}</span>
					</div>
				))
			}
		</div>
	) : null
};

export default ListStats;
